import React, { FC, memo, useCallback } from "react";
import { useTheme } from "styled-components";
import { Checkbox, Icon, ITheme } from "@evergis/ui";

import { Alias, Badge, Content, Control, IconContainer, LayerIconContainer, Main, Section } from "../styled";
import { VisibilityButton } from "./Buttons/VisibilityButton";
import { ListMenu } from "./ListMenu/ListMenu";
import { LayerGroupProps } from "../types";

export const LayerGroup: FC<LayerGroupProps> = memo(
  // eslint-disable-next-line max-lines-per-function
  ({ layer, onGroupExpand, noControl, noIcon, isDragging, isExpanding, isSelectable, isSelected, toggleSelected }) => {
    const theme = useTheme() as ITheme;
    const { name, alias, opacity, children, isExpanded, isVisible, clientData } = layer;

    const onClickGroup = useCallback(() => {
      onGroupExpand(name, isExpanded);
    }, [isExpanded, name, onGroupExpand]);

    return (
      <Main
        $color={clientData?.color || theme.palette.primary}
        $isFolder
        $isExpanding={isExpanding}
        $isExpanded={isExpanded}
        $isVisible
        onClick={onClickGroup}
      >
        {isSelectable && (
          <Checkbox checked={isSelected} onChange={() => toggleSelected(name)} onClick={e => e.stopPropagation()} />
        )}
        {!noIcon && (
          <IconContainer>
            <LayerIconContainer style={{ opacity }}>
              <Icon kind={isExpanded ? "tree_folder_open" : "tree_folder_closed"} style={{ marginLeft: -3 }} />
            </LayerIconContainer>
          </IconContainer>
        )}
        <Section>
          <Content>
            <Alias title={alias} onClick={onClickGroup}>
              {alias}
            </Alias>
            <Icon kind="expand" />
            <Control>
              <Badge>{children?.length || 0}</Badge>
              {!noControl && (
                <>
                  <VisibilityButton item={{ name, children, isVisible }} />
                  <ListMenu
                    layer={null}
                    table={null}
                    loading={false}
                    opacity={opacity}
                    name={name}
                    isVisibleItem={isVisible}
                    isDragging={isDragging}
                    isGroup
                  />
                </>
              )}
            </Control>
          </Content>
        </Section>
      </Main>
    );
  },
);
